import axios from 'axios'

export const requestMasterVisit = async (userLogin, userPassword, actualPhone) => {
    try {
        const response = await axios.post(`https://simplymail.space/request_master_visit`, {
            user_login: userLogin,
            user_password: userPassword,
            actual_phone: actualPhone
        })
        return response.data
    } catch (error) {
        console.error(error)
    }
}
